import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Index',
		component: Index
	},
	{
		path: '/home',
		name: 'Home',
		component: () => import( /* webpackChunkName: "about" */ '../views/Home.vue')
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/jobindex',
		name: 'JobIndex',
		component: () => import('../views/JobIndex.vue')
	},
	{
		path: '/jobs',
		name: 'Jobs',
		component: () => import('../views/Jobs.vue')
	},
	{
		path: '/jobinfo',
		name: 'JobInfo',
		component: () => import('../views/JobInfo.vue')
	},
	{
		path: '/production',
		name: 'Production',
		component: () => import('../views/Production.vue')
	},
	{
		path: '/productionfive',
		name: 'ProductionFive',
		component: () => import('../views/ProductionFive.vue')
	},
	{
		path: '/contactus',
		name: 'ContactUS',
		component: () => import('../views/ContactUS.vue')
	},
	{
		path: '/specialproducts',
		name: 'SpecialProducts',
		component: () => import('../views/SpecialProducts.vue')
	},
	{
		path: '/consultingservices',
		name: 'ConsultingServices',
		component: () => import('../views/ConsultingServices.vue')
	},
	{
		path: '/productcenter',
		name: 'ProductCenter',
		component: () => import('../views/ProductCenter.vue')
	},
	{
		path: '/products_4',
		name: 'Products_4',
		component: () => import('../views/Products_4.vue')
	},
	{
		path: '/newsdetail',
		name: 'NewsDetail',
		component: () => import('../views/NewsDetail.vue')
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('../views/register')
	}
]

const router = new VueRouter({
	routes
	// scrollBehavior(to, from, savedPosition) {
	//     // 始终滚动到顶部
	//     return { top: 0 }
	//   },
	,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

// 全局挂载路由导航守卫

export default router
